import { createContext } from "react";

const DF_MO0004Context = createContext();

export {DF_MO0004Context}